// MaxVapor theme JS — age gate, qty stepper, PDP variant/swatch sync
(function () {
  // ---- Age gate ----
  var gate = document.getElementById('mv-agegate');
  if (gate && !localStorage.getItem('mv_age_ok')) {
    gate.style.display = 'flex';
    var accept = document.getElementById('mv-agegate-accept');
    if (accept) accept.addEventListener('click', function () {
      localStorage.setItem('mv_age_ok', '1');
      gate.style.display = 'none';
    });
  }

  // ---- Mobile nav ----
  var navToggle = document.getElementById('mv-nav-toggle');
  if (navToggle) navToggle.addEventListener('click', function () {
    var nav = document.querySelector('.nav');
    var open = nav.classList.toggle('open');
    navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // ---- Qty stepper ----
  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      var d = parseInt(btn.getAttribute('data-qty'), 10);
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + d);
      input.value = v;
    });
  });

  // ---- PDP swatch / variant ----
  var productEl = document.getElementById('mv-product-json');
  if (!productEl) return;
  var product = JSON.parse(productEl.textContent);
  var variantInput = document.getElementById('mv-pdp-variant');
  var priceEl = document.getElementById('mv-pdp-price');
  var selected = product.options.map(function (_, i) {
    var initial = product.variants[0];
    return initial['option' + (i + 1)];
  });

  document.querySelectorAll('.pdp-swatches').forEach(function (group) {
    var idx = parseInt(group.getAttribute('data-option-index'), 10);
    group.querySelectorAll('.pdp-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        group.querySelectorAll('.pdp-swatch').forEach(function (s) { s.classList.remove('active'); });
        sw.classList.add('active');
        selected[idx] = sw.getAttribute('data-value');
        syncVariant();
      });
    });
  });

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function syncVariant() {
    var match = product.variants.find(function (v) {
      return selected.every(function (val, i) { return v['option' + (i + 1)] === val; });
    });
    if (!match) return;
    variantInput.value = match.id;
    if (priceEl) priceEl.textContent = money(match.price);
  }

  // ---- Gallery thumbs ----
  document.querySelectorAll('.pdp-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      var src = thumb.getAttribute('data-img');
      var main = document.getElementById('mv-gallery-main');
      if (main && src) main.src = src;
    });
  });
})();
